var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo",staticStyle:{"width":"100px","height":"150px"}},[_c('img',{attrs:{"src":require("../assets/admin1.png")}})])
}]

export { render, staticRenderFns }